import lodash from 'lodash';
import axios from 'axios';
import { ref } from "vue";
import * as Sentry from "@sentry/vue";
import { defineRule,configure } from 'vee-validate';
import { required, email, min,max,digits } from '@vee-validate/rules';
import { registerSW } from "virtual:pwa-register";
import {localize} from '@vee-validate/i18n';
import "vue-toastification/dist/index.css";
import "vue-select/dist/vue-select.css";
import fa from '@vee-validate/i18n/dist/locale/fa.json';
import {useToast} from "vue-toastification";
localize({fa});
const updateSW = registerSW({
  onNeedRefresh() {
    console.log("onNeedRefresh");
  },
  onOfflineReady() {
    console.log("onOfflineReady");
  },
});
window.toast = useToast();
window.APP_URL = import.meta.env.VITE_APP_URL;
window.backgroundColor = import.meta.env.VITE_APP_VARIANT == 'motra' ? 'bg-orange-custom-9' : 'bg-blue-custom-4 lg:bg-blue-custom-6';
window.activeColor = import.meta.env.VITE_APP_VARIANT == 'motra' ? 'bg-error' : 'bg-blue-custom-6 lg:bg-blue-custom-4';
window._ = lodash;
window.axios = axios;
defineRule('required', required);
defineRule('email', email);
defineRule('min', min);
defineRule('max', max);
defineRule('digits', digits);
configure({
  generateMessage: localize('fa',{
      names: {
          time: window.i18n['Time'],
          email: window.i18n['Email'],
          name: window.i18n['Name'],
          status: window.i18n['Status'],
          username: window.i18n['Username'],
          password: window.i18n['Password'],
      }
  }),
});


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
 String.prototype.capitalize = function () {
    return this.replace(/^./, function (match) {
      return match.toUpperCase();
    });
  };
  
window.progressDialog = ref(false);

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.setQuery = (router,route,key,value) => {
  let obj = Object.assign({}, route.query);
    if (value.length === 0) delete obj[key]
    else obj[key] = value;
    router.replace({
        ...router.currentRoute,
        query: obj
    });
    return obj;
}

window.getErrors = (error) => [].concat(...Object.values(error.response.data.errors));
window.networkError = (error) => {
  if(process.env.NODE_ENV !== 'production')console.log(error?.response)
  const status = error.response?.status;
  if([0,500].includes(status))window.toast.error(window.i18n['Error connecting to the server!']);
};
window.setSentry = (app) => {
  Sentry.init({
    app,
    dsn: "https://401f6c2ff7e37c05ce413647f646687c@o4507368345763840.ingest.us.sentry.io/4507369994452992",
    integrations: [
      Sentry.replayIntegration(),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
// document.addEventListener('contextmenu', event => event.preventDefault());

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.MIX_PUSHER_APP_KEY,
//     cluster: import.meta.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
